(() => {
  const name = 'nosht-campaign-coupon';
  if (customElements.get(name)) return;

  customElements.define(name, class extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._generation = (this._generation || 0) + 1;
      this._code = this.querySelector('[data-campaign-code]');
      this._button = this.querySelector('[data-campaign-copy]');
      this._status = this.querySelector('[data-campaign-copy-status]');
      if (!this._code || !this._button || !this._status) return;
      this._buttonLabel = this._button.innerHTML;
      this._copy = this._copyCode.bind(this);
      this._button.addEventListener('click', this._copy);
      this._button.disabled = false;
      this._button.hidden = false;
      this._button.removeAttribute('aria-busy');
    }

    disconnectedCallback() {
      this._connected = false;
      this._generation = (this._generation || 0) + 1;
      this._resetCopyLabel();
      if (this._button) {
        this._button.removeEventListener('click', this._copy);
        this._button.hidden = true;
      }
    }

    async _copyCode() {
      if (this._button.disabled) return;
      this._resetCopyLabel();
      const generation = this._generation;
      const code = this._code.value;
      this._button.disabled = true;
      this._button.setAttribute('aria-busy', 'true');
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(code);
        if (!this._connected || generation !== this._generation) return;
        this._status.textContent = this.dataset.success;
        this._button.textContent = this.dataset.copiedLabel || this.dataset.success;
        this._labelTimeout = setTimeout(() => {
          this._labelTimeout = null;
          if (this._connected && generation === this._generation) {
            this._button.innerHTML = this._buttonLabel;
          }
        }, 3000);
      } catch (_error) {
        if (!this._connected || generation !== this._generation) return;
        this._resetCopyLabel();
        this._status.textContent = this.dataset.failure;
        // Keep the complete code available without clipboard permission or JavaScript.
        this._code.focus({ preventScroll: true });
        this._code.select();
      } finally {
        if (this._connected && generation === this._generation) {
          this._button.disabled = false;
          this._button.removeAttribute('aria-busy');
        }
      }
    }

    _resetCopyLabel() {
      clearTimeout(this._labelTimeout);
      this._labelTimeout = null;
      if (this._button && this._buttonLabel !== undefined) {
        this._button.innerHTML = this._buttonLabel;
      }
    }
  });
})();
